import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { ICompanySummary } from 'gen/ApiClient';

export const CompaniesCacheContext = React.createContext<ICacheContext<ICompanySummary[]>>(undefined as any);
